import { Button, Stack, Typography, useTheme } from '@mui/material';
import dayjs from 'dayjs';

import { Strings } from '@app/constants';
import { AttachmentViewer, ProfileCard } from '@app/components/card';
import { ITasks } from '../type';
import { TaskStatus } from '@app/components/task-status';
import { useDialog } from '@app/hooks';

interface Props {
  taskData: ITasks;
}

export const TaskInfo = ({ taskData }: Props) => {
  const viewAttachmentPreview = useDialog();
  const theme = useTheme();
  const fields = [
    Strings.tasks.taskName,
    Strings.tasks.projectName,
    Strings.tasks.assignedBy,
    Strings.tasks.assignedOn,
    Strings.tasks.dueDate,
    Strings.tasks.attachment,
    Strings.tasks.labels,
    Strings.tasks.status,
  ];

  const data = [
    taskData?.name ?? 'NA',
    taskData?.projectName ?? 'NA',
    taskData?.assignedBy ?? 'NA',
    dayjs(taskData?.createdAt).format('DD MMM YYYY') ?? 'NA',
    dayjs(taskData?.dueDates?.endDate).format('DD MMMM YYYY') ?? 'NA',
    <Button key="task" color="primary" onClick={viewAttachmentPreview.show}>
      {Strings.button.clickHere}
    </Button>,
    <Stack key="labels" direction="row" spacing={1}>
      {taskData?.labels?.length > 0 ? (
        taskData.labels.map((label, index) => (
          <TaskStatus key={index} text={label.name} textColor={label.color} />
        ))
      ) : (
        <Stack sx={{ paddingLeft: 1 }}>
          <Typography
            sx={{
              color: theme.palette.common.black,
              fontSize: '13px',
            }}
          >
            {Strings.common.na}
          </Typography>
        </Stack>
      )}
    </Stack>,
    taskData?.listStatus,
    <TaskStatus
      key={'taskStatus'}
      text={taskData?.status}
      textColor={theme.palette.success.dark}
    />,
  ];

  return (
    <>
      <ProfileCard
        fields={fields}
        data={data}
        title={Strings.field.projectInformation}
        iconImg="ic_projects"
        desc={taskData?.description}
        Src={taskData?.projectImage || taskData?.projectName}
      />
      {viewAttachmentPreview.visible && (
        <AttachmentViewer
          open
          titleName={Strings.tasks.attachments}
          onClose={viewAttachmentPreview.hide}
          images={taskData?.attachments}
        />
      )}
    </>
  );
};
